<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditInquiry></addEditInquiry>
    </v-dialog>
</template>

<script>
    import addEditInquiry from '../Shared/AddInquiry.vue'

    // Settings Types
    import {
        Inquiry
    } from '../../store/namespace-helper'

    export default {
      name: 'inquiry-dialog',
      components: {
        addEditInquiry
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Distribution/InquiryDialog.vue